import { QFramelessDropDownList } from "./QFramelessDropDownList";
import { QList } from "./QList";

export class QListMgr {
  constructor() {
    this.fListInfo = {};
  }

  LoadListData(source, clone, id, syncKey, updateSource) {
    var targetList = this.GetListByID(id);
    var listData;

    if (!targetList) targetList = this.CreateList(this, id, source, clone, syncKey ? syncKey : id);

    if (updateSource) listData = this.UpdateExistingList(id, source);
    else listData = targetList.GetDataSource();

    return listData;
  }

  CreateList(parent, id, dataSource, resetList, syncKey) {
    var newList = new QList();
    newList.fParentPanel = parent;
    newList.fDataSource = dataSource;
    newList.fListID = id;
    newList.fSyncKey = syncKey;
    newList.fListMgr = this;
    if (resetList) newList.fResetList = resetList.slice(0);
    this.fListInfo[id] = newList;
    return newList;

    ///
  }

  CreateBinList(parent, id, dataSource, availableList, syncKey) {
    var newList = new QFramelessDropDownList();
    newList.fParentPanel = parent;
    newList.fDataSource = dataSource; // reference to data source current options
    newList.fListID = id;
    newList.fSyncKey = syncKey;
    newList.fListMgr = this;
    newList.fAvailableList = availableList.slice(0);
    this.fListInfo[id] = newList;
    return newList;
  }

  GetListByID(id) {
    if (this.fListInfo == null) return false;
    return this.fListInfo[id];
  }

  UpdateExistingList(listKey, newData, groupKey) {
    var listID = groupKey ? groupKey : listKey;
    var targetList = this.GetListByID(listID);
    if (targetList) targetList.UpdateDataSource(newData);
    return targetList.GetDataSource();
  }

  GetLastSelectedElementID(listKey, groupKey) {
    var selectedID = null;
    var listID = groupKey ? groupKey : listKey;
    var targetList = this.GetListByID(listID);
    if (targetList) selectedID = targetList.GetLastSelectedID();
    return selectedID;
  }

  GetListCount(key) {
    var length = 0;
    var targetList = this.GetListByID(key);
    if (targetList) length = targetList.GetDataSource().length;
    return length;
  }

  ResetLists() {
    this.fListInfo = {};
  }
}
